import './FixedButtonGroup.scss';
import {memo, useState} from 'react';
import ContactDialog from 'components/ContactDialog/ContactDialog';
import LogoComponent from './components/LogoComponent';
import TopRightGroup from './components/TopRightGroup';
// import ContactBtn from './components/ContactBtn';
import VolumeBtn from './components/VolumeBtn';


const FixedButtonGroup = ({
    canvasStatus,
    setCanvasStatus,
    hallwayToLoby,
    setHallwayToLoby,
}: {
    canvasStatus: boolean;
    setCanvasStatus: (status: boolean) => void;
    hallwayToLoby: () => void;
    setHallwayToLoby: any;
}) => {
    const [contactDialog, setContactDialog] = useState(false);
    const [canCancel, setCanCancel] = useState(false);

    return (
        <div
            className={`btn-wrap ${
                canvasStatus ? 'bottom' : 'top'
            }`}>
            <LogoComponent
                canvasStatus={canvasStatus}
                setCanvasStatus={setCanvasStatus}
                hallwayToLoby={hallwayToLoby}
                setHallwayToLoby={setHallwayToLoby}
            />
            <TopRightGroup
                canvasStatus={canvasStatus}
                setContactDialog={setContactDialog}
                setCanCancel={setCanCancel}
                hallwayToLoby={hallwayToLoby}
            />
            {/* <ContactBtn
                center={camMoveCenter.center}
                setContactDialog={setContactDialog}
                setCanCancel={setCanCancel}
            /> */}
            <VolumeBtn />
            <ContactDialog
                canCancel={canCancel}
                contactDialog={contactDialog}
                setCanCancel={setCanCancel}
                setContactDialog={setContactDialog}
            />


        </div>
    );
};

export default memo(FixedButtonGroup);
